import { canUseDom as isBrowser } from "../../can-use-dom";
export function detectSupportedWebpOnServer(req) {
    // 从请求头的 Accept 字段，判断是否支持 webp
    var accept = req.headers["accept"] || "";
    return /\bimage\/webp\b/.test(accept);
}
export function detectSupportedWebpOnBrowser() {
    // 无法简单的同步判断是否支持 webp，使用 framework 提供的探针
    var needleDom = document.getElementById("__al_webp_needle");
    return needleDom ? needleDom.height > 0 : false;
}
// PC业务为2，H5业务为1
export function detectDprOnServer(req) {
    // 仅能从 user-agent 判断
    // mobile 均为 2
    // windows pc 为 1 / mac pc 为2
    var ua = req.headers["user-agent"] || "";
    if (/\b(mobile|mobi)\b/.test(ua)) {
        return 2;
    }
    else if (/\bWindows\b/.test(ua)) {
        return 1;
    }
    else {
        return 2;
    }
}
export function isSupportWebp(req) {
    return isBrowser
        ? detectSupportedWebpOnBrowser()
        : req
            ? detectSupportedWebpOnServer(req)
            : false;
}
export function getDpr(req) {
    return isBrowser ? window.devicePixelRatio || 2 : req ? detectDprOnServer(req) : 2;
}
